// Layout
const websiteLayout = () => import('@/layouts/websiteLayout')

const privacyPolicy = () => import('./views/index')
// start Routes
export default [
  {
    path: '/privacy-policy',
    name: 'privacyPolicy',
    component: websiteLayout,
    children: [{
      path: '',
      name: 'privacyPolicy',
      meta: {
        name: 'privacyPolicy',
        userType: '',
        permission: '',
        breadCrumb: [
          {
            text: 'endUser.privacyPolicy',
            active: true
          }
        ]
      },
      component: privacyPolicy
    }
    ]
  }
]
